module.exports = __webpack_public_path__ + "media/customizations/riverlights/back-1e64865ca34463f142ec9158294559ed.jpg";